import { render, staticRenderFns } from "./ConfirmInAppPurchase.vue?vue&type=template&id=f96577aa&scoped=true"
import script from "./ConfirmInAppPurchase.vue?vue&type=script&lang=ts"
export * from "./ConfirmInAppPurchase.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmInAppPurchase.vue?vue&type=style&index=0&id=f96577aa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f96577aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f96577aa')) {
      api.createRecord('f96577aa', component.options)
    } else {
      api.reload('f96577aa', component.options)
    }
    module.hot.accept("./ConfirmInAppPurchase.vue?vue&type=template&id=f96577aa&scoped=true", function () {
      api.rerender('f96577aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/statics/ConfirmInAppPurchase.vue"
export default component.exports